let stripePromise: Promise<any> | null = null;

/**
 * Lazily loads Stripe.js and returns the Stripe constructor.
 * The script is loaded once and cached — subsequent calls return the same promise.
 */
export function loadStripe(): Promise<any> {
  if ((window as any).Stripe) {
    return Promise.resolve((window as any).Stripe);
  }

  if (!stripePromise) {
    stripePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.onload = () => resolve((window as any).Stripe);
      script.onerror = () => {
        stripePromise = null;
        reject(new Error('Failed to load Stripe.js'));
      };
      document.head.appendChild(script);
    });
  }

  return stripePromise;
}
